import React from "react";
import Proptypes from "prop-types";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";
import { getTranslation } from "../../../locales";

const HiddenQuestion = (props) => {
  const styles = useStyles(props);
  return (
    <div className={styles.questionWrapper}>
      <QuestionPreview
        question={props.question}
        required={props.required}
        helperText={props.helperText}
      />
      <div className={styles.answer}>
        <TextareaAutosize
          className={styles.textArea}
          data-testid="hidden"
          placeholder={getTranslation(
            props.currentLang,
            "surveyTaker:answerWillBeAutoPopulated"
          )}
          value={props.value}
          onChange={(e) => props.handleChange(e.target.value)}
          required={props.required}
          maxChar={50}
          charLimitWarnMsg={getTranslation(
            props.currentLang,
            "surveyTaker:characterLimitReached"
          )}
        />
      </div>
    </div>
  );
};

HiddenQuestion.defaultProps = {
  question: "",
  required: false,
};

HiddenQuestion.propTypes = {
  question: Proptypes.string.isRequired,
  required: Proptypes.bool.isRequired,
  helperText: Proptypes.string,
};

export default HiddenQuestion;
